export default {
  compare: {
    id: 'search_comparison_tool_hover_compare',
    defaultMessage: 'Compare',
  },
  clear: {
    id: 'search_comparison_tool_hover_clear',
    defaultMessage: 'Clear',
  },
} as const
